import { render, staticRenderFns } from "./cardWait.vue?vue&type=template&id=18529536&scoped=true"
import script from "./cardWait.vue?vue&type=script&lang=js"
export * from "./cardWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18529536",
  null
  
)

export default component.exports